function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// creates a matcher function
export default function makeMatcher() {
  var makeRegexpFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : pathToRegexp;
  var cache = {};

  // obtains a cached regexp version of the pattern
  var getRegexp = function getRegexp(pattern) {
    return cache[pattern] || (cache[pattern] = makeRegexpFn(pattern));
  };
  return function (pattern, path) {
    var _getRegexp = getRegexp(pattern || ""),
      regexp = _getRegexp.regexp,
      keys = _getRegexp.keys;
    var out = regexp.exec(path);
    if (!out) return [false, null];

    // formats an object with matched params
    var params = keys.reduce(function (params, key, i) {
      params[key.name] = out[i + 1];
      return params;
    }, {});
    return [true, params];
  };
}

// escapes a regexp string (borrowed from path-to-regexp sources)
// https://github.com/pillarjs/path-to-regexp/blob/v3.0.0/index.js#L202
var escapeRx = function escapeRx(str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
};

// returns a segment representation in RegExp based on flags
// adapted and simplified version from path-to-regexp sources
var rxForSegment = function rxForSegment(repeat, optional, prefix) {
  var capture = repeat ? "((?:[^\\/]+?)(?:\\/(?:[^\\/]+?))*)" : "([^\\/]+?)";
  if (optional && prefix) capture = "(?:\\/" + capture + ")";
  return capture + (optional ? "?" : "");
};
var pathToRegexp = function pathToRegexp(pattern) {
  var groupRx = /:([A-Za-z0-9_]+)([?+*]?)/g;
  var match = null,
    lastIndex = 0,
    keys = [],
    result = "";
  while ((match = groupRx.exec(pattern)) !== null) {
    var _match = match,
      _match2 = _slicedToArray(_match, 3),
      _ = _match2[0],
      segment = _match2[1],
      mod = _match2[2];

    // :foo  [1]      (  )
    // :foo? [0 - 1]  ( o)
    // :foo+ [1 - ∞]  (r )
    // :foo* [0 - ∞]  (ro)
    var repeat = mod === "+" || mod === "*";
    var optional = mod === "?" || mod === "*";
    var prefix = optional && pattern[match.index - 1] === "/" ? 1 : 0;
    var prev = pattern.substring(lastIndex, match.index - prefix);
    keys.push({
      name: segment
    });
    lastIndex = groupRx.lastIndex;
    result += escapeRx(prev) + rxForSegment(repeat, optional, prefix);
  }
  result += escapeRx(pattern.substring(lastIndex));
  return {
    keys: keys,
    regexp: new RegExp("^" + result + "(?:\\/)?$", "i")
  };
};